import axiosInstance from 'config/axiosInstance';
import { MAX_PAGE_SIZE } from 'config/constant';
import { fetchSearchPage, RemotePage } from 'reusable/RemoteSearch/remotePage';

/**
 * EV-493。作業・配送先の候補と、選んでいる作業の名前・同じ名前の有無。
 *
 * 以前は作業・配送先を全件（最大5,000件・100件ずつ50回）読み、候補・選んだ作業の名前（配送先の編集）・
 * 作成の結果が分からなかったときの同じ名前の有無を画面で求めていた。候補は名前で検索して20件ずつ読み
 * （並びは一覧の既定のまま）、選んでいる作業は ID（id__in）、同じ名前は名前の完全一致（name）で読む。
 * 会社の範囲はサーバーが守る。
 */
export const TASKS_PATH = '/v1/tasks/';
export const CLIENT_DELIVERIES_PATH = '/v1/client_deliveries/';

export interface TaskCandidate {
  id: number;
  name: string;
  icon: string;
}

export interface ClientCandidate {
  id: number;
  name: string;
  /** 割り当てている運転者（担当ドライバーの割り当ては、これに足して送る）。 */
  assign_drivers?: number[];
}

export function taskCandidatePage(query: string, page: number): Promise<RemotePage<TaskCandidate>> {
  return fetchSearchPage<TaskCandidate>('/v1/tasks/', query, page);
}

export function clientCandidatePage(query: string, page: number): Promise<RemotePage<ClientCandidate>> {
  return fetchSearchPage<ClientCandidate>(CLIENT_DELIVERIES_PATH, query, page);
}

/** 選んでいる作業を ID で読む（100件ずつ）。読めた作業だけを返す。 */
export async function fetchTasksByIds(ids: number[]): Promise<TaskCandidate[]> {
  const unique = Array.from(new Set(ids));
  const rows: TaskCandidate[] = [];
  for (let start = 0; start < unique.length; start += MAX_PAGE_SIZE) {
    const chunk = unique.slice(start, start + MAX_PAGE_SIZE);
    const response = await axiosInstance.get(`${TASKS_PATH}?id__in=${chunk.join(',')}&page_size=${MAX_PAGE_SIZE}`);
    rows.push(...(Array.isArray(response.data?.results) ? response.data.results : []));
  }
  return rows;
}

/** 同じ名前（完全一致）があるか。 */
export async function nameExists(path: string, name: string): Promise<boolean> {
  const response = await axiosInstance.get(`${path}?name=${encodeURIComponent(name)}&page_size=1`);
  const data = response.data ?? {};
  if (typeof data.count === 'number') return data.count > 0;
  return Array.isArray(data.results) && data.results.some((row: { name?: string }) => row?.name === name);
}
